import { ReactNode, useMemo } from "react";
import { useSelector } from "react-redux";

import LokasiIntelligenceLogo from "@/assets/svg/logo.svg?react";
import Satelite from "@/assets/svg/satelite.svg?react";
import { RootState } from "@/store";

const APP_TERMS_URL =
  "https://bvarta.com/good-corporate-governance/#pix-tab-1695295226014-6bcc688d-7f7d";

const APP_SUPPORT_URL = "https://bvarta.com/contact-us/";

const APP_HEADER_TITLE = <>Empower Your Business with LOKASI Intelligence</>;

const APP_HEADER_SUBTITLE = (
  <>
    Unlock actionable insights through advanced geospatial analytics. Visualize{" "}
    trends, optimize operations, and make smarter decisions with ease
  </>
);

export const LoginPageLayout = ({ children }: { children: ReactNode }) => {
  const partnerData = useSelector((state: RootState) => state.ui.partnerData);

  const appTermsUrl = useMemo(
    () => partnerData?.app_terms_url ?? APP_TERMS_URL,
    [partnerData?.app_terms_url]
  );
  const appSupportUrl = useMemo(
    () => partnerData?.app_support_url ?? APP_SUPPORT_URL,
    [partnerData?.app_support_url]
  );
  const appHeaderTitle = useMemo(
    () => partnerData?.app_header_title ?? APP_HEADER_TITLE,
    [partnerData?.app_header_title]
  );
  const appHeaderSubtitle = useMemo(
    () => partnerData?.app_header_subtitle ?? APP_HEADER_SUBTITLE,
    [partnerData?.app_header_subtitle]
  );

  return (
    <div className="relative min-h-screen grid grid-cols-5 xl:grid-cols-2 p-4">
      <div className="flex py-8 col-span-2 xl:col-span-1 mx-auto lg:max-w-[424px] xl:max-w-[480px] 2xl:max-w-[540px] w-full">
        <div className="flex flex-1 flex-col justify-between">
          <div className="absolute top-[52px] left-[96px]">
            {partnerData?.app_logo_url ? (
              <img
                src={partnerData.app_logo_url}
                alt="app_logo_url"
                className="max-w-[300px] max-h-[120px] w-auto h-auto object-contain"
              />
            ) : (
              <LokasiIntelligenceLogo title="Lokasi Intelligence Logo" />
            )}
          </div>
          {children}
          <div className="flex text-xs items-center justify-center gap-3">
            <a
              href={appTermsUrl}
              target="_blank"
              rel="noreferrer noopenner"
              className="text-primary-teal underline hover:cusor-pointer"
            >
              Terms of services
            </a>
            <div className="h-2.5 border-l border-l-neutral-200" />
            <a
              href={appSupportUrl}
              target="_blank"
              rel="noreferrer noopenner"
              className="text-primary-teal underline hover:cusor-pointer"
            >
              Support
            </a>
          </div>
        </div>
      </div>
      <div className="flex flex-col col-span-3 xl:col-span-1 xl:flex-1 bg-teal-700 rounded-xl py-10 px-20 justify-center">
        <div
          className="flex items-center justify-center mb-[100px] [&_svg]:h-auto [&_svg]:w-[30rem] [@media(max-height:982px)]:mb-[50px] [@media(max-height:982px)_svg]:w-16 max-[2560px]:scale-[1.25]"
          data-testid="satelite-icon"
        >
          <Satelite />
        </div>
        <h2 className="mx-auto text-white text-5xl font-bold xl:text-center leading-[60px] max-[1920px]:max-w-[617px] max-w-[617px]">
          {appHeaderTitle}
        </h2>
        <h3 className="mx-auto text-white text-base font-semibold mt-4 xl:text-center leading-[26px] max-[1920px]:max-w-[617px] max-w-[617px]">
          {appHeaderSubtitle}
        </h3>
      </div>
    </div>
  );
};

export default LoginPageLayout;
